import React from "react"
import { FoundationsEnums } from "./enum"
import { FoundationsConstants } from "./FoundationsConstants"

import { chartFilterValue, ChartSettings, IRunVuPayloadState, IVuParams, IVuSettings } from "./Redux/VisualUnits/visualUnitStateSlice"
import { IVUParamsSubCategory } from "./Redux/VisualUnits/vuParamSlice"
import { ChartPayload, TablePayload } from "./Components/Reports/ReportFrame"
import { getVUDimensionColObject, getVUDimensionRowObject, getVUFilterableObject, getVUMeasureObject, parseFilterValueAndOptions } from "./Pages/Workspace/workspace"
import { VisualUnitApiDTO_VisualUnit_Extended } from "./Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit"
import {VisualUnitApiDTO_EditSaveVisualUnit} from './Interfaces/APIContracts/VisualUnitApiDTO_EditSaveVisualUnit';

export const enumHLSearchDataType = {
        "HLAge": "HLAGE",
        "HLAge_From": "HLAGE_FROM",
        "HLAge_To": "HLAGE_TO",
        "HLCount": "HLCOUNT",
        "HLCount_From": "HLCOUNT_FROM",
        "HLCount_To": "HLCOUNT_TO",
        "HLDate": "HLDATE",
        "HLDate_Day": "HLDATE_DAY",
        "HLDate_Week": "HLDATE_WEEK",
        "HLDate_Month": "HLDATE_MONTH",
        "HLDate_Year": "HLDATE_YEAR",
        "HLDate_Quarter": "HLDATE_QUARTER",
        "HLDate_From": "HLDATE_FROM",
        "HLDate_To": "HLDATE_TO",
        "HLDate_Years": "HLDATE_YEARS",
        "HLDate_Years_Months": "HLDATE_YEARS_MONTHS",
        "HLDate_Months": "HLDATE_MONTHS",
        "HLDate_Multiple_Dates": "HLDATE_MULTIPLE_DATES",
        "HLDate_Weekdays": "HLDATE_WEEKDAYS",
        "HLDate_Period1": "HLDATE_PERIOD1",
        "HLDate_Period2": "HLDATE_PERIOD2",
        "HLDate_Period3": "HLDATE_PERIOD3",
        "HLDate_Relative_Range": "HLDATE_RELATIVE_RANGE",
        "HLDATE_New_RELATIVE_RANGE": "HLDATE_New_RELATIVE_RANGE",
        "HLDateTime_Number": "HLDATETIME_NUMBER",
        "HLDateTime_Period": "HLDATETIME_PERIOD",
        "HLDuration_Number": "HLDURATION_NUMBER",
        "HLDuration_Number_From": "HLDURATION_NUMBER_FROM",
        "HLDuration_Number_To": "HLDURATION_NUMBER_TO",
        "HLDuration_Period": "HLDURATION_PERIOD",
        "HLDuration_Period_From": "HLDURATION_PERIOD_FROM",
        "HLDuration_Period_To": "HLDURATION_PERIOD_TO",
        "HLMoney": "HLMONEY",
        "HLMoney_From": "HLMONEY_FROM",
        "HLMoney_To": "HLMONEY_TO",
        "HLNumber": "HLNUMBER",
        "HLNumber_From": "HLNUMBER_FROM",
        "HLNumber_To": "HLNUMBER_TO",
        "HLDecimal": "HLDECIMAL",
        "HLDecimal_From": "HLDECIMAL_FROM",
        "HLDecimal_To": "HLDECIMAL_TO",
        "HLTime_From": "HLTIME_FROM",
        "HLTime_To": "HLTIME_TO",
        "HLTime_Number": "HLTIME_NUMBER",
        "HLTime_Period": "HLTIME_PERIOD",
        "HLTime_Zone": "HLTIME_ZONE",
        "HLText": "HLTEXT",
        "HLBooleanTF": "HLBooleanTF",
        "HLYesNo": "HLYesNo"
    }

export const getMeasureListForVUID = (
    vuId: number,
    vuObjDataInfoFromStore: any[],
    vuParams: IVuParams[] = [],
    vuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [],
    measureList: any[] = [],
    setVuObj: any,
    vuParamsInfo: any
) => {
    //FIXME: Sagar, duplicate with function from DashboardVuParams , Working on it..
    let measuresParamsData: any = []
    let filtersParamsData: any = []
    let xAxisParamsData: any = []
    let yAxisParamsData: any = []
    let paramsFromStore: any = [...vuParams]
    let VuObjInfoFromStore: VisualUnitApiDTO_EditSaveVisualUnit[] = [...vuObj]
    //.measures
    //TODO: close inline drill thru

    if (vuParamsInfo) {
        let vuIndex = getVisualUnitParamsIndex(vuId, vuObjDataInfoFromStore)
        let indexedParams = { ...paramsFromStore[vuIndex] }
        indexedParams.params = vuParamsInfo
        let indexedVuObj = { ...VuObjInfoFromStore[vuIndex] }
        VuObjInfoFromStore[vuIndex] = {
            ...indexedVuObj,
            name: vuParamsInfo?.Name || '',
            description: vuParamsInfo?.Description || '',
            refreshInterval: vuParamsInfo?.RefreshInterval || null,
            privacyLock: vuParamsInfo?.PrivacyLock || false,
            measures: [], // Clear measures array,
            filterable: [],
            dimensionCol: [],
            dimensionRow: [],
        }

        vuParamsInfo?.MeasureList?.forEach((measure_value: any, measure_index: any) => {
            let vuMeasureObj = getVUMeasureObject()
            vuMeasureObj.id = parseInt(measure_value.MetaDataId)
            vuMeasureObj.displayOrder = parseInt(measure_value.DisplayOrder)
            vuMeasureObj.aggregateFunction = measure_value.AggregateFunctionName
            vuMeasureObj.axisSubType = parseInt(measure_value?.AxisSubType)
            vuMeasureObj.businessParameterId = parseInt(measure_value.BusinessParameterId)
            vuMeasureObj.singleValueReportId = parseInt(measure_value.SingleValueReportId)
            vuMeasureObj.factGroup = []
            vuMeasureObj.compCategoryName = []
            //filterList
            for (let i = 0; i < measureList.length; i++) {
                if (measureList[i].FieldKey == vuMeasureObj.id) {
                    for (let j = 0; j < measureList[i].ComputedCategoryName.length; j++) {
                        vuMeasureObj.compCategoryName.push(measureList[i].ComputedCategoryName[j])
                    }

                    for (let j = 0; j < measureList[i].FactGroupName.length; j++) {
                        vuMeasureObj.factGroup.push(measureList[i].FactGroupName[j])
                    }
                }
            }
            VuObjInfoFromStore[vuIndex].measures[measure_index] = vuMeasureObj
            let aggregateFunctionName = ''
            let measureDescription = ''
            if (measure_value?.BusinessParameter) {
                measureDescription =
                    measure_value.BusinessParameter.Name +
                    ' (' +
                    measure_value.BusinessParameter.BPValue +
                    ')'
            } else if (measure_value.SingleValueReport != null) {
                measureDescription =
                    measure_value.SingleValueReport.Name +
                    ' (' +
                    (measure_value.SingleValueReport.Description == ''
                        ? '-no desc-'
                        : measure_value.SingleValueReport.Description) +
                    ')'
            } else {
                aggregateFunctionName = measure_value.AggregateFunctionName
            }

            let measureParamObj = buildMeasureParameter(
                vuId,
                vuIndex,
                measure_index,
                measure_value.MetaDataId,
                measure_value.MetaData.FieldName,
                aggregateFunctionName,
                measureDescription
            )
            measuresParamsData.push(measureParamObj)
        })

        vuParamsInfo?.FilterableList?.forEach((filterable_value: any, filterable_index: number) => {
            let vuFilterableObj: any = getVUFilterableObject()
            vuFilterableObj.id = parseInt(filterable_value.MetaDataId)
            vuFilterableObj.displayOrder = parseInt(filterable_value.DisplayOrder)
            vuFilterableObj.filterValue = filterable_value.FilterValue
            vuFilterableObj.filterValueListId = filterable_value._internal_types_filterlookup //healthLevelGlobal.parseInteger(filterable_value.FilterValueListId);
            vuFilterableObj.filterDisplayText = filterable_value.FilterDisplayText
            vuFilterableObj.InputFilterType = filterable_value.InputFilterType
            switch (filterable_value.MetaData.DataType.toString()) {
                case FoundationsEnums.HLDataType.HLList:
                case FoundationsEnums.HLDataType.HLSearchList:
                    let valueAndOptions = parseFilterValueAndOptions(filterable_value.FilterValue)
                    vuFilterableObj.filterValue = valueAndOptions.filterValue
                    vuFilterableObj.filterOptions =
                        valueAndOptions.filterOptions == ''
                            ? 'INCLUDE_ANY'
                            : valueAndOptions.filterOptions
                    break
            }
            VuObjInfoFromStore[vuIndex].filterable[filterable_index] = vuFilterableObj

            let filterableParamObj = buildFilterableParameter(
                vuId,
                vuIndex,
                filterable_index,
                filterable_value.MetaDataId,
                filterable_value.MetaData.FieldName,
                filterable_value.FilterDisplayText,
                vuFilterableObj.filterOptions
            )
            filtersParamsData.push(filterableParamObj)
        })

        vuParamsInfo?.XAxisList?.forEach((xaxis_value: any, xaxis_index: number) => {
            var vuDimRowObj = getVUDimensionRowObject()
            vuDimRowObj.id = parseInt(xaxis_value.MetaDataId)
            vuDimRowObj.displayOrder = parseInt(xaxis_value.DisplayOrder)
            vuDimRowObj.metaDataBinId = parseInt(xaxis_value.MetaDataBin.Id)
            VuObjInfoFromStore[vuIndex].dimensionRow[xaxis_index] = vuDimRowObj

            var binName = ''
            if (xaxis_value.MetaDataBin.Id == 0) {
                binName = '- no bin -'
            } else {
                binName = xaxis_value.MetaDataBin.Name
            }

            var dimRowParamObj = buildDimensionRowParameter(
                vuId,
                vuIndex,
                xaxis_index,
                xaxis_value.MetaDataId,
                xaxis_value.MetaData.FieldName,
                binName
            )
            xAxisParamsData.push(dimRowParamObj)
        })

        vuParamsInfo?.YAxisList?.forEach((yaxis_value: any, yaxis_index: number) => {
            var vuDimColObj = getVUDimensionColObject()
            vuDimColObj.id = parseInt(yaxis_value.MetaDataId)
            vuDimColObj.displayOrder = parseInt(yaxis_value.DisplayOrder)
            vuDimColObj.metaDataBinId = parseInt(yaxis_value.MetaDataBin.Id)
            VuObjInfoFromStore[vuIndex].dimensionCol[yaxis_index] = vuDimColObj

            var binName = ''
            if (yaxis_value.MetaDataBin.Id == 0) {
                binName = '- no bin -'
            } else {
                binName = yaxis_value.MetaDataBin.Name
            }

            var dimColParamObj = buildDimensionColParameter(
                vuId,
                vuIndex,
                yaxis_index,
                yaxis_value.MetaDataId,
                yaxis_value.MetaData.FieldName,
                binName
            )
            yAxisParamsData.push(dimColParamObj)
        })
    }

    setVuObj(VuObjInfoFromStore)
    return VuObjInfoFromStore
}

export const findDrillThruDataPoint = (cellId: string, drillThruDPlist: any[]) => {
    //we can use this function later while launching drillthru, but as of not its not used FP-11666
    let drillThruDPObj = null;
    if (drillThruDPlist) {
        drillThruDPlist.forEach((value, index) => {
            if (value.cellId == cellId) {
                drillThruDPObj = value;
                return false;
            }
        })
    }
    return drillThruDPObj;
}

export const getVUChartSettingsObject = () => {
    let runVUSettings = {
        ShowChartSummation: false,
        ChartSortOrder: FoundationsEnums.SortOrder.System,
        ShowChartAnimation: false,
        ShowChartDataLabel: false,
        ShowChartZeroValue: false,
        ShowStacked: false,
        ShowPercentageTrend: false,
    }
    return runVUSettings
}


export const getRunVUDataObject = () => {
    let runVUData: any = {}
    runVUData.id = -1
    runVUData.tempId = -1
    runVUData.isAsync = true
    runVUData.viewerType = FoundationsEnums.VisualUnitViewerType.Table
    runVUData.callerType = FoundationsConstants.enumVUCallerType.Default
    runVUData.pageSize = 15
    runVUData.pageNumber = 1
    runVUData.grandTotal = true
    runVUData.sortColumn = ''
    runVUData.sortOrder = ''
    runVUData.forceRefresh = 0
    runVUData.privacyLock = 0
    runVUData.state = 0
    runVUData.appGuid = ''
    return runVUData
}


export let worklistVUs: number[] = [];



export const initialChartPayload = (vuId:number, ViewerType:number, dashBoardId:number, forceRefresh: number = 0, engineType:string = "newengine"): ChartPayload => {
    const runVUData = {
        visualUnitId: vuId,
        tempVisualUnitId: -1,
        isAsync: true,
        viewerType: ViewerType,
        callerType: FoundationsConstants.enumVUCallerType.Default,
        chartFilter: [] as chartFilterValue[],
        chartSwitch: {} as any,
        chartSettings: {} as any,
        forceRefresh: forceRefresh,
        privacyLock: 0,
        dashboardId: dashBoardId,
        EngineType: engineType,
        viewerTypeChanged: false,
        Is3DView:false
    }
    return runVUData
}

export const initialTablePayload = (vuId:number, dashBoardId:number, forceRefresh: number = 0, engineType:string = 'newengine'): TablePayload => {
    const runVUData = {
        visualUnitId: vuId,
        tempVisualUnitId: -1,
        isAsync: true,
        viewerType: FoundationsEnums.VisualUnitViewerType.Table,
        callerType: FoundationsConstants.enumVUCallerType.Default,
        pageNumber: 1,
        grandTotal: true,
        sortColumn: '',
        sortOrder: '',
        forceRefresh: forceRefresh,
        privacyLock: 0,
        pageSize: 10, //TODO: contene.PageSize
        dashBoardId: dashBoardId,
        EngineType: engineType,
        // TODO handle viewertypechanged
        viewerTypeChanged: false,
        tableSettings: {} as IVuSettings,
    }
    return runVUData
}

export const isTable = (viewerType: string | number) => {
    //from workspace.js file
    if (
        (viewerType == FoundationsEnums.VisualUnitViewerType.Unknown ||
        viewerType == FoundationsEnums.VisualUnitViewerType.Table )                
    ) {
        return true
    }
    return false
}
export const isChart = (viewerType: string | number) => {
    if(viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Bar ||
        viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Line ||
        viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Pie ||
        viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Scatter ||
        viewerType == FoundationsEnums.VisualUnitViewerType.Chart_StackedBar ||
        viewerType == FoundationsEnums.VisualUnitViewerType.Chart_ColumnGroup
    ){
        return true 
    }
    return false
}
export const isSummary = (VUdata : VisualUnitApiDTO_VisualUnit_Extended) => {
    if((VUdata?.ViewerType == FoundationsEnums.VisualUnitViewerType.SVU ||
        VUdata?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkList ||
        VUdata?.ViewerType == FoundationsEnums.VisualUnitViewerType.WorkListWithoutGauge)&&
        (VUdata?.XAxisList.length == 0 && VUdata?.YAxisList.length == 0))
    {
        return true
    }
    return false
}

export const getVUObject = () => {
    let vuObject: any = {}
    vuObject.id = -1
    vuObject.name = ''
    vuObject.description = ''
    vuObject.viewerType = FoundationsEnums.VisualUnitViewerType.Table
    vuObject.preview = 'N'
    vuObject.refreshInterval = 0
    vuObject.privacyLock = 0
    vuObject.measures = []
    vuObject.filterable = []
    vuObject.dimensionRow = []
    vuObject.dimensionCol = []
    return vuObject
}

export const ViewerTypeChecked = (visualUnitData: VisualUnitApiDTO_VisualUnit_Extended) => {
    if(isTable(visualUnitData.ViewerType) ||isChart(visualUnitData.ViewerType) || isSummary(visualUnitData))
    {
        return visualUnitData
    }
    else{
        if((visualUnitData?.ViewerType == FoundationsEnums.VisualUnitViewerType.SVU) &&
        (visualUnitData?.XAxisList.length != 0 || visualUnitData?.YAxisList.length != 0)){
          return    visualUnitData.ViewerType = FoundationsEnums.VisualUnitViewerType.Table
        }
    }
    return visualUnitData
}

        


export const getVUChartSwitchObject = () => {
    const runVUSwitch = {
        ApplySwitchValues: false,
        CategoryMetaDataId: -1,
        CategoryMetaDataBinId: -1,
        SeriesMetaDataId: -1,
        SeriesMetaDataBinId: -1,
        FilterMetaDataId: -1,
        FilterMetaDataBinId: -1,
    }
    return runVUSwitch
}

export const getRunVUChartDataObject = (chartSettingsStateForVuId: any) => {
    let runVUData: any = {}
    runVUData.id = -1
    runVUData.tempId = -1
    runVUData.isAsync = true
    runVUData.viewerType = FoundationsEnums.VisualUnitViewerType.Chart_Bar
    runVUData.callerType = FoundationsConstants.enumVUCallerType.Default
    runVUData.chartFilter = []
    runVUData.chartSwitch = getVUChartSwitchObject()
    runVUData.chartSettings =
        chartSettingsStateForVuId !== undefined
            ? { ...chartSettingsStateForVuId }
            : getVUChartSettingsObject()
    runVUData.forceRefresh = 0
    runVUData.privacyLock = 0
    return runVUData
}

export const getVUChartFilterObject = () => {
    const runVUCFilter = {
        metaDataId: -1,
        filterValue: "",
    }
    return runVUCFilter;
}

export const getVisualUnitParamsIndex = (vuId: number, vuObjectInfo: any[]) => {
    let vuIndex = -1
    let vuObjInfo: any[] = vuObjectInfo
    if (vuObjInfo.length) {
        vuObjInfo.forEach((itr, index) => {
            if (itr?.id == vuId) {
                vuIndex = index
                return false
            }
        })
    }
    return vuIndex
}


export const isActivePanel = (viewerType: number | string) => {
    if (viewerType == FoundationsEnums.VisualUnitViewerType.ActivePanel) {
        return true
    }
    return false
}

export const buildMeasureParameter = (vuId: number, vuIndex: number, measure_index: number, metaDataId: number, measureName: string, aggegrateFunctionName: string, measureDescription: string, selectedCategory: string = "", metaData: IVUParamsSubCategory | null = null) => {
    return {
        measureName: measureName,
        aggegrateFunctionName: aggegrateFunctionName,
        measureDescription: measureDescription,
        vuId: vuId,
        vuIndex: vuIndex,
        measure_index: measure_index,
        metaDataId: metaDataId,
        categoryName: selectedCategory,
        MetaData: metaData
    }
}
export const buildFilterableParameter = (vuId: number, vuIndex: number, filterableIndex: number, metaDataId: number, filterableName: string, filterableValueDisplay: string, filterOptions: any, metaData: any = null, filterValue: string = "", filterValueListId: number = 0) => {
    return {//vuId, vuIndex, filterableIndex, metaDataId, filterableName, filterableValueDisplay, filterOptions, refineMode
        filterableName: filterableName,
        filterableValueDisplay: filterableValueDisplay,
        vuId: vuId,
        vuIndex: vuIndex,
        filterableIndex: filterableIndex,
        metaDataId: metaDataId,
        filterOptions: filterOptions || "",
        MetaData: metaData,
        filterValueListId: filterValueListId,
        filterValue: filterValue
    }
}

export const buildDimensionRowParameter = (vuId: number, vuIndex: number, dimensionRowIndex: number, metaDataId: number, dimensionName: string, binName: string, selectedCategory: string = "", metaData: IVUParamsSubCategory | null = null, metaDataBinId: number | null = null) => {
    return {
        dimensionName: dimensionName,
        binName: binName,
        vuId: vuId,
        vuIndex: vuIndex,
        dimensionRowIndex: dimensionRowIndex,
        metaDataId: metaDataId,
        categoryName: selectedCategory,
        MetaData: metaData,
        MetaDataBinId: metaDataBinId
    }
}

export const buildDimensionColParameter = (vuId: number, vuIndex: number, dimensionColIndex: number, metaDataId: number, dimensionName: string, binName: string, selectedCategory: string = "", metaData: IVUParamsSubCategory | null = null, metaDataBinId: number | null = null) => {
    //vuId, vuIndex, dimensionColIndex, metaDataId, dimensionName, binName, refineMode
    return {
        dimensionName: dimensionName,
        binName: binName,
        vuId: vuId,
        vuIndex: vuIndex,
        dimensionColIndex: dimensionColIndex,
        metaDataId: metaDataId,
        categoryName: selectedCategory,
        MetaData: metaData,
        MetaDataBinId: metaDataBinId
    }
}

const displayTimeDifference = (dateObj: number) => {

    let timeDifferenceInSeconds = Math.floor((Date.now() - dateObj) / 1000)

    if (timeDifferenceInSeconds < 60) {
        return 'Just now'
    } else if (timeDifferenceInSeconds < 3600) {
        return (
            Math.floor(timeDifferenceInSeconds / 60) +
            (timeDifferenceInSeconds / 60 > 1 ? ' mins' : ' min')
        )
    } else if (timeDifferenceInSeconds < 864000) {
        return (
            Math.floor(timeDifferenceInSeconds / 3600) +
            (timeDifferenceInSeconds / 3600 > 1 ? ' hrs' : ' hr')
        )
    } else {
        return (
            Math.floor(timeDifferenceInSeconds / 86400) +
            (timeDifferenceInSeconds / 86400 > 1 ? ' days' : ' day')
        )
    }
}
